<div class="common-Tooltip tooltip" *ngIf="data?.toolTipType != 'LEADERBOARD_INFO'" [ngClass]="{'auto-width': data?.toolTipType === 'Personal_Widget' || data?.toolTipType === 'Shared_To_Internal'}" id="common-tooltip">
    <ng-container *ngIf="data?.toolTipType === 'Acess_Info'">
        <div class="tooltip-header entity-tooltip">
            <span class="item-name notranslate">{{data?.name}}</span>
        </div>
        <div class="tooltip-body p-t-16">
            <div class="description">
                <span class="highlight-title">Why</span>: {{data?.why}}
            </div>
            <div class="description p-t-16">
                <span class="highlight-title">What</span>: {{data?.what}}
            </div>
        </div>

        <div class="tooltip-footer p-t-16" [ngClass]="{'no-user-details': data?.hideOwnerDetails}">
            <div class="footer-row footer-row-1" *ngIf="!data?.hideOwnerDetails">

                <ng-container *ngIf="data?.isOwnerDetailsLoading; else ownerDetailsTemplate">
                    <div class="footer-avatar skeleton-loader-avatar">
                        <ngx-skeleton-loader
                            appearance="circle"
                            [theme]="{ width: '40px', height: '40px', 'margin': '0px' }"
                        ></ngx-skeleton-loader>
                    </div>

                    <div class="footer-info skeleton-loader-footer-info">
                        <ngx-skeleton-loader count="2"
                            [theme]="{ width: '140px', height: '10px', 'margin': '0px' }"
                        ></ngx-skeleton-loader>
                    </div>
                </ng-container>
                
                <ng-template #ownerDetailsTemplate>
                    <div class="footer-avatar profile-feed-avatar__wrapper" [style.background-color]="avatarColors?.bg"
                        [style.color]="avatarColors?.text">
    
                        <img *ngIf="data?.profileUrl" [src]="data?.profileUrl"
                            [alt]="(data?.firstName || '') + ' ' + (data?.lastName || '') + ' avatar'"
                            class="profile-feed-avatar__img" />
    
    
                        <div *ngIf="!data?.profileUrl" class="profile-feed-avatar__initials notranslate"
                            [style.color]="avatarColors?.text">
                            {{ initials }}
                        </div>
    
                    </div>

                    <div class="footer-info">
                        <span class="footer-name">
                            <span class="user-name">{{data?.firstName}} {{data?.lastName}}</span>
                            <span *ngIf="isLoggedInUserDetails" class="you-text">(You)</span>
                            <span *ngIf="!isLoggedInUserDetails" class="following" (mousedown)="onFollowMouseDown($event)"
                                (click)="toggleFollow($event)">{{data?.isFollowing ? 'Unfollow' : 'Follow'}}</span>
                        </span>
                    
                        <span class="footer-status">
                            <ng-container *ngIf="hasValidCertification && (data?.contributions || data?.contributions === 0)">{{data?.certification}} | </ng-container>
                            {{data?.contributions}} Contributions
                        </span>
                    </div>

                </ng-template>
            </div>

            <div class="footer-row footer-row-2">
                <span class="last-updated">
                    Last Updated: {{formatDate(data.lastUpdatedTime || '')}}
                </span>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="data.toolTipType === 'Personal_Widget'">
        <span class="disabled-text">Personal widgets cannot be added</span>
    </ng-container>

    <ng-container *ngIf="data.toolTipType === 'Shared_To_Internal'">
        <span class="disabled-text">Widgets shared only with Internal Support Users cannot be added</span>
    </ng-container>
</div>